"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.queueEvent = queueEvent;
/**
 * Queue the tc event function and keep checking until the tc_events_# function
 * is loaded to make the function call
 */
function queueEvent() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var queue = args;
  if (window.tc_events_4) {
    try {
      var _window;

      (_window = window).tc_events_4.apply(_window, queue);
    } catch (ex) {
      // TODO handle tc_events_4 exceptions
    }
  } else if (window.tc_events_3) {
    try {
      var _window2;

      (_window2 = window).tc_events_3.apply(_window2, queue);
    } catch (ex) {
      // TODO handle tc_events_3 exceptions
    }
  } else {
    setTimeout(function () {
      return queueEvent.apply(undefined, queue);
    }, 100);
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/@axa-asia/hk-tag-commander/lib/utils/tag-commander.js
// module id = 820
// module chunks = 0